
export { fetchServerXAuthWithBinaryRole } from "/builds/dd3tech/wiggot/wiggot-web/packages/utils/src/fetch-server.ts"